import { CategoryType } from "breadcommon";
import { RyeIcon } from "../rye/RyeIcon";

export function CategoryTypeIcon({
  type,
  size = "sm",
}: {
  type: CategoryType;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}): JSX.Element {
  const getColorClass = (type: CategoryType): string => {
    switch (type) {
      case "Income":
        return "text-green-500";
      case "Expense":
        return "text-blue-500";
      case "Savings":
        return "text-purple-500";
      case "Silent":
        return "text-gray-500";
      default:
        return "text-gray-500";
    }
  };

  const getIconName = (type: CategoryType): string => {
    switch (type) {
      case "Income":
        return "money_bag";
      case "Expense":
        return "payments";
      case "Savings":
        return "savings";
      case "Silent":
        return "do_not_disturb_on";
      default:
        return "money_bag";
    }
  };

  return (
    <RyeIcon
      name={getIconName(type)}
      size={size}
      fill={false}
      className={getColorClass(type)}
      tooltip={type}
    />
  );
}
